module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 title"
  }, [_vm._v("Chats")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item relative pr-2 pb-2",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'ChatRoomMobile'
          })
        }
      }
    }, [_c('img', {
      staticClass: "absolute circle-red",
      attrs: {
        "src": require("../../assets/mobile/icon/circle-red.svg"),
        "width": "16",
        "height": "16"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "horizontal-scroll__item__image"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/mobile/notification.png"),
        "width": 156,
        "height": 60
      }
    })])])
  })), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item inbox mr-2 mb-2"
    }, [_c('div', {
      staticClass: "display-flex gap-8 align-center"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": require("../../assets/mobile/notification_1.png"),
        "width": 50,
        "height": 50
      }
    }), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "text-inter-14 my-3"
    }, [_vm._v("\n        Yo bro, love your new album, are you down to come through for a\n        session w..\n      ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "text-inter-14 text-white inbox__btn",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'MessagesMobile'
          })
        }
      }
    }, [_vm._v("Reply")])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "title mt-4"
  }, [_vm._v("Activity")]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "display-flex gap-8 align-center py-3"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": require("../../assets/mobile/notification_2.png"),
        "width": 50,
        "height": 50
      }
    }), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _vm._m(3, true)])
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('Footer')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Inbox")]), _vm._v(" "), _c('div', {
    staticClass: "see-all font-weight-500"
  }, [_vm._v("See All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-inter-15"
  }, [_vm._v("Andrew Parker")]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-13"
  }, [_c('span', [_vm._v("@andrewparker")]), _vm._v(" "), _c('span', {
    staticClass: "text-black"
  }, [_vm._v("• 24m")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between algin-center full-width"
  }, [_c('div', {
    staticClass: "text-inter-14 text-grey-6"
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("@patrick")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-400"
  }, [_vm._v("followed you")])]), _vm._v(" "), _c('div', {
    staticClass: "text-inter-12 font-weight-400 text-grey-7"
  }, [_vm._v("8h")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-end"
  }, [_c('hr', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a64dcea0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/notification.vue
// module id = 1831
// module chunks = 180